<template>
  <div class="z-card">
    <p v-if="is_edit" class="row mt-4 mb-0">
      <span class="col-5 mt-1"> {{ $t('tasks.campaign.form.general.add_task') }}</span>
      <span class="col mt-1">{{ created_at }}</span>
    </p>
    <z-form-group
      v-if="task_date || !is_edit"
      class="row form-group--modal align-items-baseline z-form-item"
    >
      <z-form-input v-if="!is_edit" class="col-12">
        <date-time-picker
          type="start"
          :label="$t('tasks.campaign.form.general.create_task')"
          :datetime="date"
          @start-input="onConfirm"
          @date-pick="onChange"
        />
      </z-form-input>
    </z-form-group>
    <div v-if="is_edit" class="row mt-0 mb-2">
      <span class="col-5 mt">{{ $t('tasks.campaign.form.general.create_task') }}</span>
      <span class="col mt"> {{ task_date }} </span>
    </div>
    <!--    <p class="row mt-2">-->
    <!--      <span class="col-4 mt-2"> {{ $t('tasks.campaign.form.general.complete_task') }} </span>-->
    <!--      <date-picker-->
    <!--        v-model="form.task"-->
    <!--        :transfer="true"-->
    <!--        :rules="{ required: true }"-->
    <!--      />-->
    <!--    </p>-->
    <template v-if="user.role !== 'user'">
      <z-form-group class="row form-group--modal align-items-baseline z-form-item">
        <z-form-input class="col-12" :rules="{ required: true }">
          <select-project
            v-model="form.project_id"
            :disabled="is_completed_status"
            :options="projectsList"
          />
        </z-form-input>
      </z-form-group>
      <z-form-group class="row form-group--modal align-items-baseline z-form-item">
        <z-form-input class="col-12" :rules="{ required: true }">
          <select-group
            v-model="form.group_id"
            :disabled="is_completed_status"
            :options="groupList"
          />
        </z-form-input>
      </z-form-group>
    </template>
    <z-form-group
      class="row form-group--modal align-items-baseline z-form-item"
      style="align-items: baseline"
    >
      <z-form-input class="col-11" :rules="{ required: true }">
        <select-status
          v-model="form.task_state_id"
          :options="states_list"
          :select_project_id="form.project_id"
        />
      </z-form-input>
      <tooltip
        class="ml-3"
        placement="top"
        min-width="200"
        max-width="200"
        theme="light"
        :content="$t('shared.tooltips.status_project')"
      >
        <icon size="18" type="ios-help-circle-outline" />
      </tooltip>
    </z-form-group>
    <z-form-group
      v-if="is_delayed_status"
      class="row form-group--modal align-items-baseline z-form-item"
    >
      <z-form-input class="col-12" :rules="{ required: is_delayed_status }">
        <date-picker v-model="form.delayed_until" type="datetime" style="width: 100%" />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline z-form-item">
      <z-form-input class="col-12" :rules="{ uuid: true, max: 36 }">
        <v-text-field v-model="form.task_id" label="UUID" outlined dense />
      </z-form-input>
    </z-form-group>
  </div>
</template>

<script>
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';
  import moment from 'moment-timezone';
  import { ProjectsService } from '@projects/services/ProjectsService';
  import { GroupService } from '@administration/services/GroupService';
  import { mapGetters, mapActions } from 'vuex';
  import SelectProject from './select-project';
  import SelectGroup from './select-group';
  import SelectStatus from './select-status';
  export default {
    components: {
      SelectProject,
      SelectGroup,
      SelectStatus
    },
    props: {
      is_edit: {
        type: Boolean,
        default: false
      },
      current_task: {
        type: Object,
        default: () => ({})
      },
      states_list: {
        type: Array,
        default: () => []
      }
    },
    data: () => ({
      form: {
        assigned_to: '',
        project_id: '',
        group_id: '',
        task_date: '',
        task_id: '',
        task_state_id: '',
        created_at: '',
        delayed_until: null
      },
      is_completed_status: false,
      projectsList: {},
      groupList: {}
    }),

    computed: {
      ...mapGetters('core/auth', ['user']),
      ...mapGetters('tasks/task_card', ['is_delayed_status']),
      task_date() {
        if (this.form.task_date) {
          return moment(this.form.task_date).tz('Atlantic/Azores').format('YYYY-MM-DD HH:mm:ss');
        }
        return null;
      },
      created_at() {
        return moment(this.form.created_at).format('YYYY-MM-DD HH:mm:ss');
      }
    },

    watch: {
      current_task: {
        handler: function (val) {
          this.form = defaultsDeep(
            pick(val, [
              'task_date',
              'project_id',
              'group_id',
              'task_state_id',
              'task_id',
              'assigned_to',
              'created_at',
              'delayed_until'
            ]),
            {
              task_date: '',
              project_id: '',
              group_id: '',
              task_state_id: '',
              task_id: '',
              assigned_to: '',
              created_at: this.user.created_at,
              delayed_until: null
            }
          );
          this.form.created_at = this.form.created_at ? this.form.created_at : this.user.created_at;
        },
        immediate: true,
        deep: true
      },
      states_list: {
        handler: function () {
          this.is_completed_status = this.states_list?.find((state) => state.id === this.form.task_state_id)?.task_state === 'completed';
        },
        deep: true
      },
      'form.project_id': {
        handler: function (new_project_id) {
          const availableStates = this.states_list?.filter(function (state) {
            return state.preview_projects?.some(function (project) {
              return new_project_id === project.id;
            });
          });
          if (
            availableStates.length > 0 &&
            !availableStates.find((i) => i.id === this.form.task_state_id)
          ) {
            this.form.task_state_id = '';
          }
        },
        deep: true
      },
      'form.task_state_id': {
        handler: function (new_state_id) {
          const isStateDelayed =
            this.states_list?.find((state) => state.id === new_state_id)?.task_state === 'delayed';

          this.setIsDelayedStatus(isStateDelayed);
          if (!isStateDelayed) {
            this.form.delayed_until = null;
          }
        },
        deep: true
      }
    },

    async created() {
      await ProjectsService.getList().then((resp) => {
        this.projectsList = resp.data;

        if (this.$route.name === 'project.tasks.create') {
          this.form.project_id = this.$route.params.project_id;
        }
      });
      if (this.user.role != 'user')
        await GroupService.getList().then((resp) => (this.groupList = resp.data));
    },

    methods: {
      ...mapActions('tasks/task_card', ['setIsDelayedStatus']),
      returnInfo() {
        this.$emit('general_form', this.form);
      }
    }
  };
</script>

<style lang="scss">
  .general {
    width: 100%;
    max-width: 100%;

    label {
      width: 34.4%;
      max-width: 34.4%;
      padding-right: 15px;
    }
    .filter__item__body {
      width: 200px;
    }
  }
</style>
